import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service'
import { SearchTermservice } from '../../services/search/search-service.service';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { MatInputModule } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AddAgentEmployeeDialogComponent } from '../../components/add-agent-employee-dialog/add-agent-employee-dialog.component'
import { DeleteAgentEmployeeDialogComponent } from '../../components/delete-agent-employee-dialog/delete-agent-employee-dialog.component';
import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';

@Component({
  selector: 'app-agent-employee',
  templateUrl: './agent-employee.component.html',
  styleUrls: ['./agent-employee.component.css']
})
export class AgentEmployeeComponent implements OnInit {
  noResults: any;
  public employeeList: any[] = [];
  public agentDetails: any;
  public agentId: any;
  sortedData;
  length: any;
  message: any;
  pageSize = 10;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  displayedColumns = ['FirstName', 'EmployeeType', 'FileEdit'];
  dataSource: MatTableDataSource<EmployeeData>;
  ispaginationFlag: boolean = false;
  errMsg;
  errFlag: boolean = false;
  private subscription: Subscription;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  empName: string;
  pendingReqButton: boolean = false;
  disableDelete: boolean = false;

  constructor(public dialog: MatDialog, private router: Router, private agentEmployeeService: AgentEmployeeService, private searchTermservice: SearchTermservice) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.agentDetails = res;
    });
    this.subscription = this.agentEmployeeService.load.subscribe(res => {
      if (res === 'success') {
        this.bindEmployeesTable();
      }
    });
    this.bindEmployeesTable();
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  bindEmployeesTable() {
    this.agentEmployeeService.getAgentEmployees(this.agentId).subscribe(res => {
      this.employeeList = [];
      if (res.Status == 200 && res.Employees !== undefined && res.Employees.length > 0) {
        for (let i = 0; i < res.Employees.length; i++) {
          res.Employees[i].FirstName = res.Employees[i].FirstName.toLowerCase();
          res.Employees[i].LastName = res.Employees[i].LastName.toLowerCase();
          this.employeeList.push(res.Employees[i]);
        }
        this.message = '';
        this.dataSource = new MatTableDataSource(this.employeeList);
        this.length = this.employeeList.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        this.paginator.pageIndex = 0;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      } else if (res.Employees !== undefined && res.Employees.length == 0) {
        this.employeeList = [];
        this.dataSource = null;
        this.ispaginationFlag = false;
        this.message = "No employees found";
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  addbuttonClicked() {
    const dialogRef = this.dialog.open(AddAgentEmployeeDialogComponent, {
      disableClose: true,
      width: '80%',
      height: '50%',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  editemployees(employeeList) {
    const dialogRef = this.dialog.open(AddAgentEmployeeDialogComponent, {
      disableClose: true,
      width: '80%',
      height: '50%',
      data: { employeeData: employeeList }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteDoc(employeeList) {
    const dialogRef = this.dialog.open(DeleteAgentEmployeeDialogComponent, {
      disableClose: true,
      width: '400px',
      height: '250px',
      data: { employeeData: employeeList }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  selectedEmployee(employeeList) {
    this.empName = this.toTitleCase(employeeList.FirstName + " " + employeeList.LastName);
    localStorage.setItem('EmployeeName', this.empName);
    localStorage.setItem('dbId', employeeList._id);
    localStorage.setItem('EmployeeId', employeeList.EmployeeId);
    this.router.navigate(['agent/agentemployee', this.agentId, 'EmployeeSummary', employeeList.EmployeeId]);
  }

  toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  pendingRequest(status){
    if(status){
      if(status.toLowerCase().replace(' ','') === 'pendingrequest'){
        if((this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
          this.pendingReqButton = true;
          this.disableDelete = false;
        }else{
          this.pendingReqButton = false;
          this.disableDelete = true;
        }
      }else{
        this.pendingReqButton = false;
        this.disableDelete = false;
      }
    }else{
      this.pendingReqButton = false;
      this.disableDelete = false;
    }
  }

  validateRequest(employeeList): void {

    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: employeeList, pagename: 'deleteEmployee' },
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}

export interface EmployeeData {
  FirstName: String;
  EmployeeType: String;
  FileEdit: any;
}



// WEBPACK FOOTER //
// ./src/app/components/agent-employee/agent-employee.component.ts